/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const e={hasAnimatedSinceResize:!0,hasEverUpdated:!1};export{e as globalProjectionState};
//# sourceMappingURL=state.js.map
